(()=>{
function initialise(root){
 if(root.dataset.initialised)return;root.dataset.initialised='true';
 const host=root.parentElement,slides=[...root.querySelectorAll('.g3-slide')],gallery=host.querySelector('.g3-gallery-dialog'),viewer=host.querySelector('.g3-view-dialog');
 if(!gallery||!viewer)return;
 let index=0,focusBefore;
 const find=s=>root.querySelector(s)||host.querySelector(s);
 function pause(scope){scope.querySelectorAll('video').forEach(v=>v.pause());}
 function select(i){
 index=Math.max(0,Math.min(i,slides.length-1));pause(root);pause(gallery);
 slides.forEach((el,k)=>el.classList.toggle('active',k===index));
 find('.g3-count').textContent=`${slides.length?index+1:0} / ${slides.length}`;
 for(const s of ['.g3-prev','.g3-dialog-prev'])find(s).disabled=index===0;
 for(const s of ['.g3-next','.g3-dialog-next'])find(s).disabled=index>=slides.length-1;
 find('.g3-open').disabled=!slides.length;
 if(gallery.open&&slides[index]){const clone=slides[index].cloneNode(true);clone.classList.add('active');clone.querySelectorAll('[id]').forEach(e=>e.removeAttribute('id'));find('.g3-gallery-stage').replaceChildren(clone);find('.g3-dialog-count').textContent=`${index+1} / ${slides.length}`;}
 }
 function openGallery(){if(!slides.length)return;focusBefore=document.activeElement;gallery.showModal();select(index);}
 root.querySelector('.g3-stage').addEventListener('click',e=>{if(e.target.closest('img'))openGallery();});
 find('.g3-open').addEventListener('click',openGallery);
 for(const s of ['.g3-prev','.g3-dialog-prev'])find(s).addEventListener('click',()=>select(index-1));
 for(const s of ['.g3-next','.g3-dialog-next'])find(s).addEventListener('click',()=>select(index+1));
 find('.g3-gallery-close').addEventListener('click',()=>gallery.close());
 gallery.addEventListener('close',()=>{pause(gallery);focusBefore?.focus();});
 gallery.addEventListener('keydown',e=>{if(e.target.closest('video'))return;if(e.key==='ArrowRight'){e.preventDefault();select(index+1);}if(e.key==='ArrowLeft'){e.preventDefault();select(index-1);}});
 find('.g3-view-open').addEventListener('click',()=>viewer.showModal());find('.g3-view-close').addEventListener('click',()=>viewer.close());viewer.addEventListener('close',()=>find('.g3-view-open').focus());
 for(const dialog of [viewer,gallery])dialog.addEventListener('click',e=>{if(e.target!==dialog)return;const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();});
 const mediaQuery=matchMedia('(max-width:760px)');mediaQuery.addEventListener('change',()=>pause(root));
 select(0);
}
function load(){document.querySelectorAll('[data-gemstone-r6]').forEach(initialise);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',load);else load();document.addEventListener('shopify:section:load',load);
})();

if (!customElements.get('gemstone-viewing-film')) {
 customElements.define('gemstone-viewing-film', class extends HTMLElement {
  connectedCallback() {
   this.videos = [...this.querySelectorAll('video')];
   this.abort = new AbortController();
   const options = {signal:this.abort.signal};
   this.reduce = matchMedia('(prefers-reduced-motion: reduce)');
   this.compact = matchMedia('(max-width:760px)');
   this.inView = false;
   const still = video => {video.pause();video.classList.add('g3-film-waiting');};
   const selected = () => this.compact.matches && this.videos[1] ? this.videos[1] : this.videos[0];
   this.reconcile = () => {
    this.videos.forEach(video => {
     if(video!==selected() || this.reduce.matches || video.dataset.failed){still(video);return;}
     if(this.inView && !document.hidden) video.play().catch(()=>still(video));
     else video.pause();
    });
   };
   this.videos.forEach(video => {
    video.muted=true; video.controls=false;
    video.addEventListener('playing',()=>{
     if(video!==selected() || this.reduce.matches || !this.inView || document.hidden) still(video);
     else video.classList.remove('g3-film-waiting');
    },options);
    video.addEventListener('error',()=>{video.dataset.failed='true';still(video);},options);
   });
   this.reduce.addEventListener('change',this.reconcile,options);
   this.compact.addEventListener('change',this.reconcile,options);
   document.addEventListener('visibilitychange',this.reconcile,options);
   this.observer=new IntersectionObserver(entries=>{this.inView=entries[0].isIntersecting;this.reconcile();},{threshold:0.3});
   this.observer.observe(this);
  }
  disconnectedCallback(){this.observer?.disconnect();this.abort?.abort();this.videos?.forEach(video=>video.pause());}
 });
}
